/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MaterialEducationalDetailAliases {
  CARD_MATERIAL_EDUCATION_0 = 'card-material-education-0',
  DATE_DETAIL_TEXT = 'date-detail-text',
  DETAIL_IMAGE = 'detail-image',
  DETAIL_LAYOUT = 'detail-layout',
  FETCH_DETAIL_CARDS = 'fetch-detail-cards',
  HTML_VIEWER_DETAIL = 'html-viewer-detail',
  MATERIAL_DETAIL_FETCH = 'material-detail-fetch',
  MATERIAL_DETAIL_LAYOUT = 'material-detail-layout',
  MATERIAL_DETAIL_PANEL = 'material-detail-panel',
  PANEL_ALT_IMAGE = 'panel-alt-image',
  PANEL_CARDS = 'panel-cards',
  PANEL_HTML = 'panel-html',
  PANEL_LATERAL_PADDING = 'panel-lateral-padding',
  PANEL_LOWER = 'panel-lower',
  PANEL_TAG = 'panel-tag',
  SEGMENTED_CONTROL_DETAIL_CARDS = 'segmented-control-detail-cards',
  SUBTITLE_DETAIL_TEXT = 'subtitle-detail-text',
  TAG_CATEGORY = 'tag-category',
  TEXT_READ_MORE_ABOUT = 'text-read-more-about',
  TITLE_DETAIL_TEXT = 'title-detail-text',
}
export { MaterialEducationalDetailAliases };
